/* global Intercom */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Menu } from 'semantic-ui-react';
import axios from 'axios';
import styles from './App.scss';

class OptionsMenu extends Component {

  static propTypes = {
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.signOut = this.signOut.bind(this);
    this.getHelp = this.getHelp.bind(this);
    this.transition = this.transition.bind(this);
  }

  getHelp() {
    // eslint-disable-next-line new-cap
    if (typeof Intercom !== undefined) Intercom('show');
  }

  signOut() {
    axios.get('/users/sign_out').then(() => {
      window.location = '/';
    });
  }

  transition(e) {
    e.preventDefault();
    this.props.router.push(e.target.getAttribute('to') || '/');
  }

  render() {
    const { viewer } = this.props;
    const name = `${viewer ? viewer.first_name : ''} ${viewer
      ? viewer.last_name
      : ''}`;
    return (
      <Dropdown
        floating
        icon='angle down'
        labeled
        className='icon basic'
        text={name}
        className={styles.grey}
      >
        <Dropdown.Menu style={{ left: 'auto', right: 0, minWidth: '120px' }}>
          <Dropdown.Item onClick={this.transition} to='/templates'>Templates</Dropdown.Item>
          <Dropdown.Item onClick={this.transition} to='/leads'>Lead Capture</Dropdown.Item>
          <Dropdown.Divider />
          {typeof Intercom !== undefined &&
            <Dropdown.Item onClick={this.getHelp}>Help</Dropdown.Item>}
          <Dropdown.Item onClick={this.transition} to='/settings'>Settings</Dropdown.Item>
          <Dropdown.Item onClick={this.signOut}>Sign Out</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

}

export default OptionsMenu;



// WEBPACK FOOTER //
// ./webpack/components/App/OptionsMenu.js